import { render, staticRenderFns } from "./DataTable_NDW.vue?vue&type=template&id=af28df04&scoped=true&"
import script from "./DataTable_NDW.vue?vue&type=script&lang=js&"
export * from "./DataTable_NDW.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af28df04",
  null
  
)

export default component.exports